import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const StickyBook = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href="mailto:akamba81@gmail.com"
          data-testid="sticky-book-button"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35 }}
          className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2.5 rounded-full bg-gold px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.18em] font-medium text-ink shadow-[0_10px_40px_rgba(212,175,55,0.35)] transition-colors duration-300 hover:bg-ivory"
        >
          <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ink/50 opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-ink" />
          </span>
          Book Now
        </motion.a>
      )}
    </AnimatePresence>
  );
};
